/*
 * Design: Command Center — Dark Operations Dashboard
 * Final conversion section — urgency + reason-why (Belcher framework)
 * SMS CTA with supporting proof
 */

import { MessageCircle, Zap } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      <div className="gradient-divider mb-24" />

      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-500/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-500/20 mb-6">
          <Zap size={14} className="text-red-400" />
          <span className="text-red-300 text-sm font-medium">Every minute costs you money</span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
          Right Now, a Lead Is Waiting
          <br />
          <span className="gradient-text">for a Call That Won't Come</span>
        </h2>
        <p className="text-zinc-300 text-lg leading-relaxed max-w-2xl mx-auto mb-4">
          Every hour without AI follow-up is another lead going cold, another deal lost to a competitor who responded faster. The math is simple — speed wins.
        </p>
        <p className="text-zinc-400 text-base leading-relaxed max-w-2xl mx-auto mb-10">
          Interested in learning how we help agencies automate their entire follow-up system? Text me directly and let's explore what's possible for your business.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="sms:+15039987760?body=Hi%20Luis%2C%20I%27m%20interested%20in%20learning%20more%20about%20your%20AI%20systems%20and%20GHL%20services."
            className="inline-flex items-center justify-center gap-2 px-10 py-4 text-base font-semibold text-white rounded-lg transition-all duration-200 hover:opacity-90 hover:shadow-xl hover:shadow-purple-500/25 group"
            style={{
              background: "linear-gradient(135deg, #7C3AED, #D946EF)",
            }}
          >
            Text Me
            <MessageCircle size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </div>

        <p className="text-zinc-400 text-sm mt-6">
          Text (503) 998-7760 to discuss your specific needs.
        </p>
      </div>
    </section>
  );
}
